export const addWetLease = {
  wetlease_lessee: '',
  details: '',
  start_date: null,
  end_date: null,
  remarks: ''
}
export const wetleaseHd = [
  { label: 'Name', sortOption: false },
  { label: 'Details', sortOption: false },
  { label: 'Start Date', sortOption: false },
  { label: 'End Date', sortOption: false },
  { label: 'Attachment(s)', sortOption: false },
  { label: 'Action', sortOption: false },
];
export const errorCode = {
  wetlease_lessee:{
    0:'',
    1: 'Please enter Wetlease Name'
  },
  wetlease_lesseeObj: {
    required: true
  }
}
